<template>
  <div class="c-footer">
    <div class="c-footer-content-greater1200">
      <!-- <div class="c-footer-content">
        <img class="c-footer-logo" src="@/assets/images/footer/footer-logo.svg" alt="">
      </div> -->
      <div class="c-footer-block">
        <div class="c-footer-main">
          <div
            class="c-footer-list"
            v-for="(obj, i) in baseData.guideList"
            :key="i"
          >
            <div class="c-footer-list-type">{{ obj.name }}</div>
            <div
              class="c-footer-list-label"
              v-for="(item, j) in obj.list"
              @click="openUrl(item.url, item.event)"
              :key="j"
            >
              {{ item.label }}
            </div>
          </div>

          <!-- <div class="c-footer-ver-split"></div> -->

          <div class="c-footer-list">
            <div class="c-footer-list-type">联系我们</div>
            <div class="c-footer-list-label">客服电话</div>
            <div class="c-footer-list-label-2">
              {{ baseData.contact.phone.value }}
            </div>
            <div class="c-footer-list-label">服务时间</div>
            <div class="c-footer-list-label-2">
              {{ baseData.contact.time.value }}
            </div>
            <div class="c-footer-list-label">扫码联系客服</div>
            <div class="c-footer-list-label-2">
              <img
                class="qrcodeImg indent"
                :src="baseData.contact.qr.img"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-footer-content1200">
      <!-- <div class="c-footer-content">
        <img class="c-footer-mini-logo" src="@/assets/images/footer/mini-footer-logo.svg" alt="">
      </div> -->
      <div class="c-footer-content c-footer-mini-block">
        <div class="c-footer-mini-main">
          <div v-for="obj in baseData.guideList" :key="obj.name">
            <div class="c-footer-list-mini-type" @click="clickType(obj.info)">
              {{ obj.name }}
              <span>
                <img
                  :class="foldMenu[obj.info] ? 'imgTransform' : ''"
                  src="@/assets/images/footer/ico-arrow.png"
                />
              </span>
            </div>
            <template v-if="foldMenu[obj.info]">
              <div
                class="c-footer-list-mini-type c-footer-list-mini-label"
                v-for="item in obj.list"
                :key="item.label"
                @click="openUrl(item.url, item.event)"
              >
                {{ item.label }}
              </div>
            </template>
          </div>

          <div class="c-footer-min-contact">
            <div>
              <div
                class="c-footer-min-contact-label"
                :style="`background-image: url(${baseData.contact.qr.icon})`"
              >
                {{ baseData.contact.qr.label }}
              </div>
              <img class="qrcodeImg" :src="baseData.contact.qr.img" alt="" />
            </div>
            <div>
              <div
                class="c-footer-min-contact-label"
                :style="`background-image: url(${baseData.contact.phone.icon})`"
              >
                {{ baseData.contact.phone.label }}
              </div>
              <div class="c-footer-min-contact-value">
                {{ baseData.contact.phone.value }}
              </div>
            </div>
            <div>
              <div
                class="c-footer-min-contact-label"
                :style="`background-image: url(${baseData.contact.time.icon})`"
              >
                {{ baseData.contact.time.label }}
              </div>
              <div class="c-footer-min-contact-value">
                {{ baseData.contact.time.value }}
              </div>
            </div>

            <!-- <div class="c-footer-list-type pl28" :style="`background-image: url(${baseData.contact.qr.icon})`">
              {{ baseData.contact.qr.label }}</div>
            <img class="qrcodeImg" :src="baseData.contact.qr.img" alt=""> -->
          </div>
        </div>
      </div>
    </div>

    <div class="c-footer-content c-footer-copyright-block">
      <div>
        <label class="c-footer-copyright">{{ baseData.copyright.top1 }}</label>
        <label class="c-footer-copyright top2">{{
          baseData.copyright.top2
        }}</label>
        <br class="br" />
        <label class="c-footer-copyright">{{ baseData.copyright.top3 }}</label>
        <label class="c-footer-copyright">{{ baseData.copyright.top4 }}</label>
      </div>
      <div>
        <label class="c-footer-copyright">{{
          baseData.copyright.bottom1
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { footerData } from './config.js';
import { getFromPage, getPageName } from '@/common/utils/index';
import infoCollect from '@/common/infoCollect';

export default {
  name: 'c-footer',
  data() {
    return {
      baseData: footerData,
      foldMenu: {
        price: false,
        support: false,
        community: false,
        service: false,
      },
    };
  },
  methods: {
    openUrl(url, info) {
      if (url.startsWith('http')) {
        infoCollect.setAppEndExtraData('button_click', info, 'PC', {
          page_name: getPageName(),
          from_item: getFromPage(),
        });
        location.href = url;
      } else {
        infoCollect.dwCollectData('button_click', info, 'PC', {
          page_name: getPageName(),
          from_item: getFromPage(),
        });
        this.$router.push(url);
      }
      sessionStorage.removeItem('PAGE_SCROLL_TOP_CACHE_PC');
    },
    clickType(type) {
      this.foldMenu[type] = !this.foldMenu[type];
    },
  },
};
</script>

<style lang="scss" scoped>
.c-footer {
  min-height: 10vh;
  min-width: 768px;
  position: relative;

  &-content {
    max-width: 1200px;
    min-width: 704px;
    margin: 0 auto;
  }

  &-logo {
    width: 172px;
    height: 36px;
    margin-top: 48px;
    margin-bottom: 17px;
  }

  &-split {
    width: 100%;
    height: 1px;
    position: relative;
    background: rgba(13, 13, 13, 0.12);
  }

  &-ver-split {
    height: 318px;
    width: 1px;
    background: rgba(13, 13, 13, 0.12);
    margin-right: 100px;
    margin-left: 15px;
  }

  &-block {
    margin: 0 auto;
    max-width: 1200px;
  }

  &-main {
    display: flex;
    margin: 0 auto;
    max-width: 1200px;
    align-content: center;
    padding-top: 60px;
  }

  &-list {
    width: 218px;
    min-height: 368px;
  }
  &-list:not(:last-child) {
    margin-right: 26px;
  }

  &-list-type {
    white-space: nowrap;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: left center;
    color: var(--kd-color-text-primary, rgba(13, 13, 13, 0.9));
    font-weight: 600;
    margin-bottom: 24px;
    font-size: var(--kd-font-size-base, 14px);
    line-height: var(--font-line-height-base, 22px);
  }

  &-list-label {
    cursor: pointer;
    margin-bottom: 12px;
    font-size: var(--kd-font-size-base, 14px);
    line-height: var(--font-line-height-base, 22px);
    color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
  }
  &-list-label-2 {
    color: rgba(17, 17, 17, 1);
    font-weight: 600;
    margin-top: -4px;
    margin-bottom: 18px;
    font-size: var(--kd-font-size-middle, 16px);
    line-height: var(--font-line-height-middle, 24px);
  }

  &-copyright-block {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    padding-top: 32px;
    padding-bottom: 80px;
    > div:last-child {
      margin-top: 8px;
    }
  }

  &-copyright {
    font-size: var(--kd-font-size-base, 14px);
    line-height: var(--font-line-height-base, 22px);
    color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
    margin-right: 24px;
    margin-bottom: 8px;
    &.top2::before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url('~@/assets/images/footer/safety.png');
      background-size: 100%;
      background-repeat: no-repeat;
      vertical-align: middle;
      margin-right: 3px;
    }
  }

  .pl28 {
    padding-left: 28px;
  }

  .mt72 {
    margin-top: 6px;
  }

  .mt4 {
    margin-top: 4px;
  }

  .mb26 {
    margin-bottom: 26px;
  }

  .mr47 {
    margin-right: 47px;
  }

  .qrcodeImg {
    width: 120px;
    height: 120px;
    margin-left: -6px;
  }
}

.c-footer-content1200 {
  display: none;
}
.br {
  display: none;
}

@include responsiveV2($width-m) {
  .c-footer-content,
  .c-footer-block {
    max-width: 840px;
    width: 100%;
  }
  .br {
    display: block;
  }
}
</style>
